import { api } from "../../lib";

export interface Role {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateRoleInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateRoleInput extends Partial<CreateRoleInput> {
  id: string;
}

export const rolesService = {
  getAll: async () => {
    return api.get<Role[]>("/roles");
  },

  getActive: async () => {
    return api.get<Role[]>("/roles/active");
  },

  getById: async (id: string) => {
    return api.get<Role>(`/roles/${id}`);
  },

  create: async (input: CreateRoleInput) => {
    return api.post<Role>("/roles", {
      name: input.name,
      description: input.description,
      isActive: input.isActive ?? true,
    });
  },

  update: async (input: UpdateRoleInput) => {
    const { id, ...updates } = input;
    return api.put<Role>(`/roles/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/roles/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.patch<Role>(`/roles/${id}/toggle-active`, { isActive });
  },
};
